import ScoreDisplay from './ScoreDisplay'

export default ScoreDisplay
